import { render, staticRenderFns } from "./PsiSimpleList.vue?vue&type=template&id=7de14b81&scoped=true&"
import script from "./PsiSimpleList.vue?vue&type=script&lang=js&"
export * from "./PsiSimpleList.vue?vue&type=script&lang=js&"
import style0 from "./PsiSimpleList.vue?vue&type=style&index=0&id=7de14b81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de14b81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent})
